function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SOL_svg__clip0_1_82)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.873 21.19a.982.982 0 01.694-.287H29.51a.49.49 0 01.347.837l-4.73 4.73a.982.982 0 01-.694.286H.49a.49.49 0 01-.347-.837l4.73-4.73z",
  fill: "url(#SOL_svg__paint0_linear_1_82)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.873 3.53c.189-.18.438-.286.694-.286H29.51a.49.49 0 01.347.837l-4.73 4.73a.982.982 0 01-.694.286H.49a.49.49 0 01-.347-.837l4.73-4.73z",
  fill: "url(#SOL_svg__paint1_linear_1_82)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.127 12.303a.982.982 0 00-.694-.286H.49a.49.49 0 00-.347.837l4.73 4.73c.181.18.43.286.694.286H29.51a.49.49 0 00.347-.837l-4.73-4.73z",
  fill: "url(#SOL_svg__paint2_linear_1_82)"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__paint0_linear_1_82",
  x1: 27.223,
  y1: 0.418,
  x2: 10.652,
  y2: 32.157,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00FFA3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DC1FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__paint1_linear_1_82",
  x1: 19.977,
  y1: -3.364,
  x2: 3.407,
  y2: 28.374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00FFA3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DC1FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SOL_svg__paint2_linear_1_82",
  x1: 23.577,
  y1: -1.485,
  x2: 7.006,
  y2: 30.253,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00FFA3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DC1FFF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SOL_svg__clip0_1_82"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "98a0b1705dd11b46c58e59c323655476.svg";
export { SvgSol as ReactComponent };